import gql from 'graphql-tag';

export const ACTIVATE_TEMP_USER_MUTATION = gql`
  mutation registerTemporaryActivate($token: String!) {
    registerTemporaryActivate(token: $token) {
      success
      error
      token
    }
  }
`;
